export default "__VITE_ASSET__CGAsmYJk__"